import { combineReducers } from "redux";
import authReducer from "./authReducers";
import propertyReducer from "./propertyRedecer";
import languageReducer from "./languageRedecure";
import saveOtpReducer from "./otpReducers";
import homeReducer from "./homeReducer";
import chatReducer from "./chatReducer";
import favriteReducer from "./favriteRdducers";
import hiddenReducer from "./hiddenReducers";
import applyPropertyReducer from "./appplyPropertyReducers";
import getFavouritePropertiesReducer from "./favouritePropertyReducer";
import getHiddenPropertiesReducer from "./hiddenPropertyReducer";
import getAppliedPropertiesReducer from "./appliedPropertyReducer";
import cmsReducer from "./cmsReducer";
import userWishListReducer from "./userWishListReducer";
import subscriptionReducer from "./subscriptionReducer";
import notificationReducer from "./notificationReducer";
import forgotPasswordReducer from "./forgotPasswordReducer";
import registrationStepReducer from "./registrationStepReducer"

export default combineReducers({
  auth: authReducer,
  forgotOtp:forgotPasswordReducer,
  properties: propertyReducer,
  language: languageReducer,
  saveOtp: saveOtpReducer,
  home: homeReducer,
  chatMessages: chatReducer,
  favorites: favriteReducer,
  hiddens: hiddenReducer,
  applyproperty: applyPropertyReducer,
  favouriteProperties: getFavouritePropertiesReducer,
  hiddenProperties: getHiddenPropertiesReducer,
  appliedProperties: getAppliedPropertiesReducer,
  cmsPages: cmsReducer,
  userWishList: userWishListReducer,
  subscription: subscriptionReducer,
  notifications: notificationReducer,
  registration:registrationStepReducer
});
